import { Component, Input, OnInit } from '@angular/core';
import { NavService } from '../../_services/_nav.service';
import { AliadoUsuarioService } from '../../_services/aliado-usuario.service';
import { AliadoUsuario } from '../../_models/aliado-usuario';
import { AliadoSucursal } from '../../_models/aliado-sucursal';

@Component( {
  selector: 'app-aliados-usuarios',
  templateUrl: 'aliados-usuarios-listado.component.html'
} )

export class AliadosUsuariosListadoComponent implements OnInit {


  @Input() sucursal: AliadoSucursal;
  @Input() detalle: boolean;
  aliUsuarios: AliadoUsuario[] = [];
  columnas: any = [];
  carTabla = false;
  busqueda: string;
  seccion = 'L';
  aliSeleccionado: AliadoUsuario;

  constructor( private navServicio: NavService,
               private aliUsuariosService: AliadoUsuarioService ) {
  }

  ngOnInit(): void {
    this.columnas = [
      { field: 'usuarioSistema', header: this.navServicio.buscarMensaje( 'ALIADOSUSUARIOS.LBL_USUARIO' ), sort: true },
      { field: 'nombreTercero', header: this.navServicio.buscarMensaje( 'ALIADOSUSUARIOS.LBL_NOMBRE' ), sort: true },
      { field: 'telefono', header: this.navServicio.buscarMensaje( 'ALIADOSUSUARIOS.LBL_TELEFONO' ), sort: true },
      { field: 'indicadorHabilitado', header: this.navServicio.buscarMensaje( 'LBL_HABILITADO' ), sort: false },
      { field: 'det', header: this.navServicio.buscarMensaje( 'LBL_ACCIONES' ), sort: false }
    ];

    this.cargarDatos();
  }

  crearAliadoUsuario() {
    this.aliSeleccionado = null;
    this.seccion = 'E';
  }

  verAliadoUsuario( aliado: AliadoUsuario ) {
    this.aliSeleccionado = aliado;
    this.seccion = 'D';
  }

  editarAliadoUsuario( aliado: AliadoUsuario ) {
    this.aliSeleccionado = aliado;
    this.seccion = 'E';
  }

  cambiarSeccion( valor: boolean ) {
    if ( valor ) {
      this.cargarDatos();
    }
    this.seccion = 'L';
  }

  cargarDatos() {
    this.carTabla = true;
    this.aliUsuariosService.listadoPorSucursal( this.sucursal.idAliadoSucursal ).subscribe( listado => {
      this.aliUsuarios = listado;
      this.carTabla = false;
    } );
  }
}
